import React from 'react'
import AWS from "aws-sdk";
const useVideoConfigS3 = () => {
   const bucketName =  process.env.REACT_APP_S3_BUCKET_VIDEOS;
    const s3 = new AWS.S3({
        accessKeyId: process.env.REACT_APP_ACCESS_KEY_VIDEOS,
        secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY_VIDEOS,
        region: process.env.REACT_APP_REGION_VIDEOS,
      });
  return [s3,bucketName]
}

export default useVideoConfigS3